
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerships",
      function () {
        return require("private-next-pages/partnerships.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnerships"])
      });
    }
  